export function getMenuListItemControlRole({ mode }) {
    if (mode === "select") {
        return "option";
    }
    if (mode === "menu") {
        return "menuitem";
    }
    return "button";
}
